import React from "react";
import { AppPage, MimaText } from "../../components";
import styles from "../../assets/styles/News/News.module.scss";
import moment from "moment";

const ViewMoreNews = ({ selectedNews }) => {
  return (
    <AppPage pageTitle="More News Info">
      <div className={styles.container}>
        <div>
          <section className={styles.container_top}>
            <div className={styles.container_top__item}>
              <MimaText variant="body">News Title:</MimaText>
              <MimaText variant="bodyBold">{selectedNews.title}</MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">News Summary:</MimaText>
              <MimaText variant="bodyBold">{selectedNews.summary}</MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Date Created:</MimaText>
              <MimaText variant="bodyBold">
                {moment(selectedNews.createdAt).format("DD/MM/YYYY HH:mm a")}
              </MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Action Call:</MimaText>
              <MimaText variant="bodyBold">
                {selectedNews.action.buttonTitle}
              </MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Action Url:</MimaText>
              <MimaText variant="bodyBold">{selectedNews.action.url}</MimaText>
            </div>
          </section>
          <section className={styles.container_bottom}>
            <MimaText align="center" variant="subtitleBold" mt={2} mb={2}>
              News Body
            </MimaText>
            <MimaText variant="body">{selectedNews.text}</MimaText>
          </section>
        </div>
        <div className={styles.imgContainer}>
          {selectedNews?.imageUrls?.map((x) => (
            <div className={styles.imgContainer_card} key={x._id}>
              <MimaText variant="body">{`Image For ${x?.key}`}</MimaText>
              <img
                src={x.url}
                alt={x.key}
                className={styles.imgContainer_img}
              />
            </div>
          ))}
        </div>
      </div>
    </AppPage>
  );
};
export default ViewMoreNews;
